module.exports = __webpack_public_path__ + "img/7.f8f8f6c7.png";